module.exports = __webpack_public_path__ + "img/special-offer.930ff226.png";